import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { SquareImageUpload } from '@/components/molecules/square-image-upload.molecule'

import type { AgentNodeFormSchemaType } from '../agency-node-form.schema'
import { AgentNodeModelField } from './agent-node-model-field.atom'
import { AgentNodeNameField } from './agent-node-name-field.atom'

interface AgentNodeIdentitySectionProps {
  form: UseFormReturn<AgentNodeFormSchemaType>
  modelList: LlmModel[]
  isLoadingModels: boolean
  imagePreviewUrl: string | null
  onImageChange: (file: File | null) => void
  onImageRemove: () => void
}

export const AgentNodeIdentitySection = ({
  form,
  modelList,
  isLoadingModels,
  imagePreviewUrl,
  onImageChange,
  onImageRemove,
}: AgentNodeIdentitySectionProps): ReactNode => (
  <div className="agent-node-identity flex gap-4">
    <SquareImageUpload
      imageUrl={imagePreviewUrl}
      fallbackText={form.watch('label') || 'Agent'}
      onImageChange={onImageChange}
      onImageRemove={onImageRemove}
      size="lg"
      uploadTooltip="Upload agent avatar"
      changeTooltip="Change avatar"
      removeTooltip="Remove avatar"
    />
    <div className="flex flex-1 flex-col gap-4">
      <AgentNodeNameField form={form} />
      <AgentNodeModelField form={form} modelList={modelList} isLoadingModels={isLoadingModels} />
    </div>
  </div>
)

AgentNodeIdentitySection.displayName = 'AgentNodeIdentitySection'
